import React from "react";
import {
  Header,
  Modal,
  Label,
  Button,
  Input,
  Checkbox,
  Grid,
  Loader,
  Icon,
  Dropdown,
  Segment,
  Portal
} from "semantic-ui-react";
import Flagship from "../../core/flagship";



const DropdownOption = ({ text, image }) => {

  return (
    <div style={{display:"flex", alignItems:"center", gap:".25rem"}}>
      {image ? <img
        src={image.src}
        alt={text}
        style={{
          height: "1.5rem",
          lineHeight: "1.5rem",
          marginRight: ".5rem"
        }}
      /> : null}
      <span style={{ display: "inline-block", verticalAlign: "middle" }}>
        {text}
      </span>
    </div>
  );
};


function dropdownOptions(data, includeImage = false) {

  return data.map(option => ({
    key: option.key,
    desc:option.description,
    value: parseInt(option.id),
    text: (
      <DropdownOption 
        text={option.text} 
        image={includeImage ? { src: `/assets/platform-${option.key.toLowerCase()}.png` } : null} 
      />
    )
  }));
}


class RegisterCampaignModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.register = this.register.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.handleObjectivePortalClose = this.handleObjectivePortalClose.bind(this);
    this.handleObjectivePortalOpen = this.handleObjectivePortalOpen.bind(this);
    this.handleTacticPortalClose = this.handleTacticPortalClose.bind(this);
    this.handleTacticPortalOpen = this.handleTacticPortalOpen.bind(this);
  }

  

  getInitialState() {
    
    return {
      platform:null,
      tactic:[],
      objective:null,
      platformOptions:[],
      tacticOptions:[],
      objectiveOptions:[],
      title:'',
      registeredName:null,
      loading:true,
      objectivePortalOpen:false,
      tacticPortalOpen:false
    };
  }

  componentDidMount() {
    this.getDropdownOptions();
  }

  getDropdownOptions() {
    const self = this;
    Flagship.get(
      "register-campaign-options",
      {},
      function(response) {
        if (response.data.success === true) {

          self.setState({
            platformOptions:response.data.options.platforms.map((item) => {
              item["value"] = parseInt(item.id);
              return item;
            }),
            tacticOptions:response.data.options.tactics.map((item) => {
              item["value"] = parseInt(item.id);
              return item;
            }),
            objectiveOptions:response.data.options.objectives.map((item) => {
              item["value"] = parseInt(item.id);
              return item;
            }),
            loading: false
          });
        } else {
          console.error("Failed to get dropdown options.");
          Flagship.notify("Error getting dropdown options.","error");
        }
      },
      function(err) {
        console.error(err);
        Flagship.notify("Error getting dropdown options.","error");
      }
    );
  }

  handleObjectivePortalClose() {
    const newState = Object.assign({},this.state);
    newState.objectivePortalOpen = false;
    this.setState(newState);
  }
  handleObjectivePortalOpen() { 
    const newState = Object.assign({},this.state);
    newState.objectivePortalOpen = true;
    this.setState(newState);
  }

  handleTacticPortalClose() {
    const newState = Object.assign({},this.state);
    newState.tacticPortalOpen = false;
    this.setState(newState);
  }
  handleTacticPortalOpen() { 
    const newState = Object.assign({},this.state);
    newState.tacticPortalOpen = true;
    this.setState(newState);
  }

  

  handleCopy() {
    if (this.state.registeredName) {
      navigator.clipboard.writeText(this.state.registeredName).then(() => {
        Flagship.notify("Copied campaign name.", "success");
      }).catch((err) => {
        console.error("Failed to copy text: ", err);
      });
    }
  }

  register() {

    const self=this;
    const data = {
      "io_product": self.props.ioProduct.id,
      "product_type": self.props.ioProduct.io_product_type,
      "title": self.state.title,
      "platform": self.state.platform,
      "tactic": self.state.tactic,
      "objective": self.state.objective,
      "campaign_id": self.props.ioProduct.id.toString().padStart(8, '0') || null
    };

    Flagship.post("register-campaign", 
      data,
        function (response) {

          if (response.data.success === true) {
            Flagship.notify("Campaign registered.", "success");
          let newState = Object.assign({},self.state);
          newState.registeredName = `${self.props.ioProduct.id.toString().padStart(8, '0')} | ${self.state.title}`;
          self.setState(newState);
          } else {
            Flagship.log("error", "Failed to register campaign.");
          }
        }
      );    
  }
  

  render() {

    const selectedPlatform = this.state.platformOptions.find((platform) => platform.value === this.state.platform);

    return (
      <Modal
      size="small"
      open={true}
      onClose={this.props.onClose}
      closeIcon
          >
            <Header>Register Campaign</Header>
            <Modal.Content>
              {this.state.registeredName ? (
                <div>
                  <h3>Success!</h3>
                  {this.state.platform ? (
                  <p>Please use the following campaign name (exactly as-is) on on {selectedPlatform ? selectedPlatform.text : 'the platform'}.</p>
                  ) : (
                    <p>Your campaign has been registered with a unique reference ID that will help migrate it to TapOrders.</p>
                  ) }
                  <div style={{ margin: "1rem 0", display: "flex", alignItems: "center" }}>
                    <Input
                      fluid
                      type="text"
                      readOnly
                      onClick={(e)=>e.preventDefault()}
                      value={this.state.registeredName}
                      style={{ marginRight: "0.5rem", flex: "1" }}
                    />
                    <Button onClick={this.handleCopy}>
                      <Icon name="copy" /> Copy
                    </Button>
                  </div>
              </div>
              ): (
              <div>
              <Grid stackable style={{marginBottom:"1rem"}}>
                <Grid.Column width={8} style={{paddingBottom:"0"}}>
                <div>
                  <Label color="black" style={{marginBottom:".5rem"}}>Client</Label>
                </div>
                <div style={{paddingLeft:".25rem"}}>{this.props.client} ({this.props.market})</div>
                </Grid.Column>
                <Grid.Column width={8} style={{paddingBottom:"0"}}>
                  <div>
                  <Label color="black" style={{marginBottom:".5rem"}}>Product</Label>
                  </div>
                  <div style={{paddingLeft:".25rem"}}>{this.props.ioProduct.io_product_key} - {this.props.ioProduct.io_product_name}</div>
                </Grid.Column>                
              </Grid>
               {this.state.loading ? <div><Loader className="flagship-loader" active inline="centered" /></div> : 
              <Grid stackable style={{marginBottom:"1rem"}}>

                {this.props.ioProduct.io_product_type === 'seo-local' ? (

                  <Grid.Column width={16} style={{paddingBottom:"0",paddingTop:"2rem"}}>
                    <p><strong>Important:</strong> You only need to register local SEO campaigns where a single Flagship line item corresponds to more than one location.</p>
                  <Label htmlFor="campaign-desc" color="blue" style={{marginBottom:".5rem"}}>Campaign Title (w/ Location Name)</Label>
                  <Input fluid size="large" id="campaign-desc" value={this.state.title} name="title" onChange={(_,{value}) => {
                    let newState = Object.assign({},this.state);
                    newState.title = value;
                    this.setState(newState);
                  }}/></Grid.Column>

                ) : (
                  <Grid.Row>
                <Grid.Column width={8} style={{paddingBottom:"0"}}>
                  <Label htmlFor="campaign-platform" color="blue" style={{marginBottom:".5rem"}}>Platform {this.props.ioProduct.io_product_type}</Label>
                  <Dropdown
                    placeholder="Select a platform..."
                    search
                    id="campaign-platform"
                    fluid
                    value={this.state.platform}
                    options={dropdownOptions(this.state.platformOptions,true)}
                    onChange={(_,{value}) => {
                      let newState = Object.assign({},this.state);
                      newState.platform = value;
                      this.setState(newState);
                    }}
                    style={{minHeight:"54px", display:"flex", alignItems:"center"}}
                    selection />
                  </Grid.Column>
                  <Grid.Column width={8} style={{paddingBottom:"0"}}>
                    <Label htmlFor="campaign-objective" color="blue" style={{marginBottom:".5rem"}}>Campaign Objective                      
                    </Label>

                    <button className="icon-green-on-hover" style={{border:"0",padding:"0", background:"transparent"}} onClick={this.handleObjectivePortalOpen}><Icon color="blue" style={{cursor:"pointer"}} size="large" name="question circle" /></button>
                       <Portal
                        open={this.state.objectivePortalOpen}

                      >
                        <div onClick={this.handleObjectivePortalClose} style={{display:"flex",alignItems:"center", left: '0%',
                            position: 'fixed',
                            top: '0%',
                            justifyItems:"center",
                            height:"100%",
                            width:"100%",
                            zIndex: "9998"}}>
                        <Segment
                          onClick={(e)=>e.stopPropagation()}
                          style={{
                            margin:"auto", maxWidth:"900px",minWidth:"300px",
                            background:"#fff",
                            border:"2px solid #14294E",
                            position:"relative",
                            boxShadow:"1px 1px 15px rgba(0,0,0,.5)",

                          }}
                        >
                          <button className="icon-red-on-hover" style={{position:"absolute",right:"16px", top:"16px", border:"0",background:"transparent", cursor:"pointer",zIndex:"9999"}} onClick={this.handleObjectivePortalClose}><Icon size="large" name="close"/></button>
                          <div style={{overflowY:"auto", overflowX:"hidden", height:"95vh",padding:".5rem"}}>
                            <h3>Objective Reference</h3>
                            <Grid>
                              <Grid.Row columns={3}>
                                {this.state.objectiveOptions.map((item, i) => (
                                  <Grid.Column key={`objective-${i}`} width={5}>
                                    <div style={{ paddingBottom: "2rem" }}>
                                      <strong>
                                        <button
                                          title="Select this objective"
                                          className="underline-on-hover"
                                          style={{
                                            padding: "0",
                                            border: "0",
                                            color: "#111",
                                            background: "transparent",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            let newState = Object.assign({}, this.state);
                                            newState.objective = item.value;
                                            this.setState(newState, this.handleObjectivePortalClose);
                                          }}
                                        >
                                          {item.text}
                                        </button>
                                        :
                                      </strong>{" "}
                                      {item.description}{" "}
                                      {item.examples ? (
                                        <em style={{ display: "block", color: "#666", marginTop: ".25em" }}>
                                          Examples: {item.examples}
                                        </em>
                                      ) : null}
                                    </div>
                                  </Grid.Column>
                                ))}
                              </Grid.Row>
                            </Grid>
                          </div>
                        </Segment>
                        </div>
                      </Portal>

                    <Dropdown
                      placeholder="Select objective..."
                      search
                      id="campaign-objective"
                      fluid
                      value={this.state.objective}
                      options={dropdownOptions(this.state.objectiveOptions)}
                      onChange={(_,{value}) => {
                        let newState = Object.assign({},this.state);
                        newState.objective = value;
                        this.setState(newState);
                      }}
                      style={{minHeight:"54px", display:"flex", alignItems:"center"}}
                      selection />
                  </Grid.Column>
                  <Grid.Column width={16} style={{paddingBottom:"0",marginTop:"1rem"}}>
                    <Label htmlFor="campaign-tactic" color="blue" style={{marginBottom:".5rem"}}>Targeting Tactic(s)</Label>
                    <button className="icon-green-on-hover" style={{border:"0",padding:"0", background:"transparent"}} onClick={this.handleTacticPortalOpen}><Icon color="blue" style={{cursor:"pointer"}} size="large" name="question circle" /></button>
                       <Portal
                        open={this.state.tacticPortalOpen}

                      >
                        <div onClick={this.handleTacticPortalClose} style={{display:"flex",alignItems:"center", left: '0%',
                            position: 'fixed',
                            top: '0%',
                            justifyItems:"center",
                            height:"100%",
                            width:"100%",
                            zIndex: 1000,}}>
                       <Segment
                          onClick={(e)=>e.stopPropagation()}
                          style={{
                            margin:"auto", maxWidth:"900px",minWidth:"300px",
                            background:"#fff",
                            border:"2px solid #14294E",
                            position:"relative",
                            boxShadow:"1px 1px 15px rgba(0,0,0,.5)"
                          }}
                        >
                          <button className="icon-red-on-hover" style={{position:"absolute",right:"16px", top:"16px", border:"0",background:"transparent", cursor:"pointer", zIndex:"9999"}} onClick={this.handleTacticPortalClose}><Icon size="large" name="close"/></button>
                          <div style={{overflowY:"auto", overflowX:"hidden", height:"95vh",padding:".5rem"}}>
                            <h3>Tactic Reference</h3>
                            <Grid>
                              <Grid.Row columns={3}>
                                {this.state.tacticOptions.map((item, i) => (
                                  <Grid.Column key={`tactic-${i}`} width={5}>
                                    <div style={{ paddingBottom: "2rem" }}>
                                      <strong>
                                        <button
                                          title="Select this tactic"
                                          className="underline-on-hover"
                                          style={{
                                            padding: "0",
                                            border: "0",
                                            color: "#111",
                                            background: "transparent",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            let newState = Object.assign({}, this.state);
                                            if (!newState.tactic.includes(item.value))
                                              newState.tactic.push(item.value);
                                            this.setState(newState, this.handleTacticPortalClose);
                                          }}
                                        >
                                          {item.text}
                                        </button>
                                        :
                                      </strong>{" "}
                                      {item.description}{" "}
                                      {item.examples ? (
                                        <em style={{ display: "block", color: "#666", marginTop: ".25em" }}>
                                          Examples: {item.examples}
                                        </em>
                                      ) : null}
                                    </div>
                                  </Grid.Column>
                                ))}
                              </Grid.Row>
                            </Grid>
                          </div>
                        </Segment>
                        </div>
                      </Portal>
                    <div className="checkbox-grid">
                      {dropdownOptions(this.state.tacticOptions).map((option, i) => {
                        return (
                          <div key={`checkbox-container-${i}`} className="checkbox-container">
                            <Checkbox
                              checked={this.state.tactic && this.state.tactic.includes(option.value)}
                              onChange={(e, data) => {
                                let newState = Object.assign({}, this.state);
                                if (data.checked) {
                                  newState.tactic.push(option.value);
                                } else {
                                  newState.tactic = newState.tactic.filter((item) => item !== option.value);
                                }
                                this.setState(newState);
                              }}
                              className="custom-checkbox"
                              id={`checkbox-${option.key}`}
                            />

                            <label
                              htmlFor={`checkbox-${option.key}`}
                              className={this.state.tactic && this.state.tactic.includes(option.value) ? 'checked' : 'unchecked'}
                              style={{ marginLeft: ".25rem", cursor: "pointer" }}
                              onClick={() => {
                                let newState = Object.assign({}, this.state);
                                if (newState.tactic.includes(option.value)) {
                                  newState.tactic = newState.tactic.filter((item) => item !== option.value);
                                } else {
                                  newState.tactic.push(option.value);
                                }
                                this.setState(newState);
                              }}
                            >
                              {option.text}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </Grid.Column>
                  <Grid.Column width={16} style={{paddingBottom:"0",paddingTop:"2rem"}}>
                    <Label htmlFor="campaign-desc" color="blue" style={{marginBottom:".5rem"}}>Campaign Title</Label>
                    <Input fluid size="large" id="campaign-desc" value={this.state.title} name="title" onChange={(_,{value}) => {
                      let newState = Object.assign({},this.state);
                      newState.title = value;
                      this.setState(newState);
                    }}/>
                  </Grid.Column></Grid.Row>)}
                </Grid>}
              </div>)}
              
            </Modal.Content>
            <Modal.Actions>
            {this.state.registeredName ? 
            <div>
            <span style={{display:"inline-block",margin:".5rem .5rem .5rem"}}><small>Using this campaign name links it to our data cloud.</small></span>
            </div>:
            <div>
            <span style={{display:"inline-block",margin:".5rem .5rem .5rem"}}>{ selectedPlatform ? <small>Once you finish registering, you'll get a campaign name to use on {selectedPlatform.text }.</small> : ( this.props.ioProduct.io_product_type === "seo-local" ? <small>Enter a descriptive name, e.g. including the location.</small> : <small>Select a platform to get started.</small>) }</span>
            {this.state.title && ((this.state.platform && this.state.objective && this.state.tactic) || this.props.ioProduct.io_product_type  === "seo-local") ? (
              <Button primary onClick={this.register}>
                Register Campaign
              </Button>) : (
                <Button primary disabled>
                Missing Required Info
              </Button>
              )}
              </div>}
              </Modal.Actions>
          </Modal>
    );
  }
}
export default RegisterCampaignModal;


// WEBPACK FOOTER //
// ./src/components/modals/RegisterCampaignModal.js